import React from 'react';

import './AppMenu.scss';

export interface AppMenuLink {
  label: React.ReactNode;
  id: string;
  active?: boolean;
  /** Host owns navigation. Mutually exclusive with `href`. */
  onClick?: () => void;
  /** Renders as `<a href>`. */
  href?: string;
  /** Only meaningful when `href` is set. */
  external?: boolean;
}

export interface AppMenuSection {
  /** Mono caps; e.g. "FDTR". */
  header: React.ReactNode;
  /** Bootstrap Icons class. */
  icon?: string;
  links: ReadonlyArray<AppMenuLink>;
}

export interface AppMenuProps {
  /** Filter by permission before passing in. */
  sections: ReadonlyArray<AppMenuSection>;
  open?: boolean;
  className?: string;
}

/** Vertical side menu, 200 px when open. NOT from Claude Design. */
export const AppMenu: React.FC<AppMenuProps> = ({
  sections,
  open = true,
  className,
}) => {
  if (!open) return null;
  return (
    <nav
      className={`wb-menu${className ? ' ' + className : ''}`}
      aria-label="Primary navigation"
    >
      {sections.map((section, sIdx) => (
        <div key={sIdx} className="wb-menu__section">
          <div className="wb-menu__header">
            {section.icon && <i className={`bi ${section.icon} wb-menu__header-icon`} aria-hidden />}
            <span className="wb-menu__header-label">{section.header}</span>
          </div>
          <ul className="wb-menu__links">
            {section.links.map((link) => (
              <li key={link.id} className="wb-menu__link-row">
                {link.href ? (
                  <a
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noreferrer' : undefined}
                    className={`wb-menu__link${link.active ? ' is-active' : ''}`}
                  >
                    {link.label}
                  </a>
                ) : (
                  <button
                    type="button"
                    className={`wb-menu__link${link.active ? ' is-active' : ''}`}
                    onClick={link.onClick}
                  >
                    {link.label}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};

export default AppMenu;
